import TermsOfService from '@/components/term-of-condition';

const TermsPage = () => {
  return <TermsOfService />;
};

export default TermsPage;
